import { useState } from 'react';
import {
  QueryClient,
  QueryClientProvider,
  QueryCache
} from '@tanstack/react-query';
import { useSnack } from '../snackBar';
import { AxiosError } from 'axios';
import { ErrorResponse } from '@partnerconnect-monorepo/types/ErrorResponse';
import { useNavigate } from 'react-router';
import { ApiErrorCodes } from '../../constants/apiErrorCodes';

export function QueryProvider({ children }: { children: React.ReactNode }) {
  const snack = useSnack();

  const navigate = useNavigate();

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: (failureCount, error) => {
              if (
                (error as AxiosError<ErrorResponse>).response?.status ===
                ApiErrorCodes.NotFound
              ) {
                return false;
              }

              return failureCount <= 3;
            }
          }
        },
        queryCache: new QueryCache({
          onSuccess: (_, query) => {
            if (query?.meta?.successMessage) {
              snack.success(query.meta.successMessage as string);
            }
            if (query.meta?.onSuccessRedirectUrl) {
              navigate(query.meta.onSuccessRedirectUrl);
            }
          },
          onError: (_, query) => {
            if (query?.meta?.errorMessage) {
              snack.error(query.meta.errorMessage as string);
            }
            if (query.meta?.onErrorRedirectUrl) {
              navigate(query.meta.onErrorRedirectUrl);
            }
          }
        })
      })
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
